<div class="tag" [ngClass]="rarityType()" [class]="size()">
    {{ tagLabel() }}
</div>